var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PhotoGalleryComponent',{attrs:{"photos":this.plant.originalLabelPhotos,"base-compressed-photo-url":_vm.labelCompressedPhotoPath,"base-origin-photo-url":_vm.labelOriginPhotoPath,"deletePhoto":_vm.deleteLabelPhoto,"isAdmin":_vm.isAdmin,"photo-type":`labelPhoto`}})
}
var staticRenderFns = []

export { render, staticRenderFns }